import  React, { useState } from "react";
import { Box, Container, Grid, Text, GridItem, Input, Button, useToast, Textarea } from "@chakra-ui/react";
import firebase from '../Helpers/Firebase';



const firestore = firebase.firestore();

export default function Contact(props){


    const toast = useToast();
    const initialValues = {
        fullName: '',
        phone: '',
        email: '',
        message: ''
    }


    const [values, setValues] = useState(initialValues);
    const [isLoading, setLoading] = useState(false);
    const contactsRef = firestore.collection('contacts');



    const handleChange = e => {
        var { name, value } = e.target;
        setValues({
            ...values, 
            [name]: value,
        })

    }




      const addUser = async(e) => {
        e.preventDefault();
        setLoading(true)
        await contactsRef.add({
            fullName: values.fullName,
            phone: values.phone,
            email: values.email,
            message: values.message,
            createdAt: firebase.firestore.FieldValue.serverTimestamp()
          });


          toast({
            title: "Thank you.",
            description: "Thank you for contacting us.",
            status: "success",
            duration: 5000,
            isClosable: true,
          });
      
          setLoading(false);

        setValues({...initialValues});
        e.target.reset();
    }




    return(
        <div>
            <Box pb={"120px"} pt={"80px"}>
                <Container>
                    <Text 
                    fontSize="36px"
                    fontWeight={900}
                    textAlign="center"
                    pb={10}>
                        Contact Us
                    </Text>
                    <form onSubmit={addUser} className="form">
                    <Grid templateColumns="repeat(2, 1fr)"  templateRows="repeat(4, 1fr)" gap={"10px 20px"}>
                        <GridItem  >
                            <Input variant="filled"  value={values.fullName} onChange={handleChange} type="text"  name="fullName" placeholder="Full Name" py={7} _focus={{ borderColor: "#4f8df7", backgroundColor: "transparent" }} />
                        </GridItem>
                        <GridItem   >
                            <Input variant="filled" value={values.phone} onChange={handleChange}  type="tel"  name="phone" placeholder="Phone Number" py={7} _focus={{ borderColor: "#4f8df7", backgroundColor: "transparent" }} />
                        </GridItem>
                        <GridItem colSpan={2}    >
                            <Input variant="filled" value={values.email} onChange={handleChange}  type="email"  name="email" placeholder="Email" py={7} _focus={{ borderColor: "#4f8df7", backgroundColor: "transparent" }} />
                        </GridItem>
                        <GridItem colSpan={2}   >
                            <Textarea variant="filled" value={values.message}  onChange={handleChange} type="text" name="message" py={7} _focus={{ borderColor: "#4f8df7", backgroundColor: "transparent" }} placeholder="Write message here..." />
                        </GridItem>
                        <GridItem colSpan={2} pt={4}  >
                            <Button  
                            
                            isLoading={isLoading}  
                            disabled={!values.email, !values.fullName, !values.phone, !values.message}
                            type="submit"
                            bg="#71a6ff"
                                _hover={{ bg: "#4f8df7" }}
                                _focusWithin={{ bg: "#4f8df7" }}
                                size="md" 
                                color="white"
                                py={7} 
                                w={"full"} >
                                Submit
                            </Button>
                        </GridItem>
                    </Grid>
                    </form>
                </Container>

            </Box>


        </div>
    )
}